import React, { useState, useEffect } from 'react';
import UsersBulkDeleteModal from './UsersBulkDeleteModal';

const UsersBulkActions = ({ selectedUsers, clearSelectedUsers, loadUsers }) => {
  const [bulkAction, setBulkAction] = useState('');
  const [isBulkDeleteModalOpen, setIsBulkDeleteModalOpen] = useState(false);

  useEffect(() => {
    if (selectedUsers.length === 0) {
      setBulkAction('');
    }
  }, [selectedUsers]);

  const handleBulkAction = async () => {
    if (!selectedUsers.length) {
      alert('No users selected.');
      return;
    }

    if (bulkAction === 'delete') {
      setIsBulkDeleteModalOpen(true);
    }
  };

  return (
    <div className="bulk-actions-container">
      <select
        className="bulk-actions-select"
        value={bulkAction}
        onChange={(e) => setBulkAction(e.target.value)}
        style={{
          backgroundColor: selectedUsers.length > 0 ? '#f8f8f8' : '#f2f2f2',
          color: selectedUsers.length > 0 ? '#000' : '#999',
        }}
      >
        <option value="">Bulk Actions</option>
        <option value="delete">Delete</option>
      </select>
      <button
        className="button secondary"
        onClick={handleBulkAction}
        disabled={!bulkAction || selectedUsers.length === 0}
      >
        Apply
      </button>

      <UsersBulkDeleteModal
        isOpen={isBulkDeleteModalOpen}
        onClose={() => {
          setIsBulkDeleteModalOpen(false);
          clearSelectedUsers();
        }}
        onSuccess={() => {
          loadUsers();
          setIsBulkDeleteModalOpen(false);
          clearSelectedUsers();
          setBulkAction('');
        }}
        users={selectedUsers}
      />
    </div>
  );
};

export default UsersBulkActions;